import script from "./SessionsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionsPage.vue?vue&type=script&setup=true&lang=js"

import "./SessionsPage.vue?vue&type=style&index=0&id=c7b22844&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7b22844"]])

export default __exports__